import { useEffect, useState } from "react"
import { Container, Table, TBody, Td, Th, Thead, Tr } from "./styles"
import { IScoreProps } from "./types"
import Loader from "../../components/Loader"
import { useTheme } from "styled-components"
import { useNavigate, useParams } from "react-router-dom"
import * as ConvidadoHistoryService from '../../services/ConvidadoHistory/ConvidadoHistory'
import { toast } from "react-toastify"
import { errorHandle } from "../../utils/errorHandle"
import Title from "../../components/Title"
import GroupButtons from "../../components/GroupButtons"
import Button from "../../components/Button"
import { RelatorioPagantesDTO, RelatorioPagantesRetornoDTO, ScoreDTO } from "../../models"
import Form from "../../components/Form"
import Input from "../../components/Input"
import * as EventoService from "../../services/Evento/EventoService"

const Score: React.FC<IScoreProps> = () => {
    const [loading, setLoading] = useState<boolean>(false)
    const [dados, setDados] = useState<ScoreDTO[]>([])
    const [idadeMeia, setIdadeMeia] = useState<number | undefined>(undefined)
    const [idadeInteira, setIdadeInteira] = useState<number | undefined>(undefined)
    const [dadosRelatorio, setDadosRelatorio] = useState<RelatorioPagantesRetornoDTO | undefined>(undefined)

    const [totalQrCode, setTotalQrCode] = useState<number>(0)
    const [totalManual, setTotalManual] = useState<number>(0)
    const [totalGeral, setTotalGeral] = useState<number>(0)

    const theme = useTheme()
    const { eventoId, eventoDescricao } = useParams()
    const navigate = useNavigate()

    useEffect(() => {
        getScore()
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        getTotalizador()
        // eslint-disable-next-line
    }, [dados])

    const getScore = async (): Promise<void> => {
        setLoading(true)
        await ConvidadoHistoryService.buscarScore(eventoId!)
            .then((res) => {
                setDados(res.data)
            })
            .catch((err) => toast.error(errorHandle(err)))
            .finally(() => setLoading(false))
    }

    const getTotalizador = () => {
        setTotalQrCode(dados.reduce((acumulador, item) => acumulador + item.entrouQrCode, 0))
        setTotalManual(dados.reduce((acumulador, item) => acumulador + item.entrouManual, 0))
        setTotalGeral(dados.reduce((acumulador, item) => acumulador + item.total, 0))
    }

    const handleRelatorioPagantes = async (): Promise<void> => {
        setLoading(true)
        const req: RelatorioPagantesDTO = {
            eventoId: eventoId!,
            idadeMeia: idadeMeia,
            idadeInteira: idadeInteira
        }
        await EventoService.relatorioPagantes(req)
            .then((res) => setDadosRelatorio(res.data))
            .catch((err) => toast.error(errorHandle(err)))
            .finally(() => setLoading(false))
    }

    const handleLimparRelatorio = (): void => {
        setIdadeMeia(undefined)
        setIdadeInteira(undefined)
        setDadosRelatorio(undefined)
    }

    return(
        <>
            {
                loading
                    ? <Loader />
                    : <Container>
                        <Title color={theme!.colors.warning} size={30}>Score</Title>
                        <Title color={theme!.colors.info} size={20}>{eventoDescricao!}</Title>
                        <Table>
                            <Thead>
                                <Tr>
                                    <Th>Usuário</Th>
                                    <Th>Entrou Qr Code</Th>
                                    <Th>Entrou Manual</Th>
                                    <Th>Entrou Total</Th>
                                </Tr>
                            </Thead>
                            <TBody>
                                {
                                    dados.map(d => 
                                        <Tr key={d.usuario}>
                                            <Td>{d.usuario}</Td>
                                            <Td>{d.entrouQrCode}</Td>
                                            <Td>{d.entrouManual}</Td>
                                            <Td>{d.total}</Td>
                                        </Tr>
                                    )
                                }
                                <Tr>
                                    <Th>Total</Th>
                                    <Th>{totalQrCode}</Th>
                                    <Th>{totalManual}</Th>
                                    <Th>{totalGeral}</Th>
                                </Tr>
                            </TBody>
                        </Table>
                        <Title color={theme!.colors.warning} size={30}>Relatório de Pagantes</Title>
                        <Form>
                            <Input 
                                width={45}
                                widthMobile={45}
                                label="Idade Meia" 
                                placeholder="Idade Meia" 
                                type='number' 
                                value={idadeMeia} 
                                onChange={(e) => setIdadeMeia(e.target.value ? parseInt(e.target.value) : undefined)} 
                            />
                            <Input 
                                width={45}
                                widthMobile={45}
                                label="Idade Inteira" 
                                placeholder="Idade Inteira" 
                                type='number' 
                                value={idadeInteira} 
                                onChange={(e) => setIdadeInteira(e.target.value ? parseInt(e.target.value) : undefined)} 
                            />
                        </Form>
                        <GroupButtons>
                            <Button 
                                $backgroundColor={theme!.colors.info}
                                type="button"
                                onClick={handleRelatorioPagantes}
                            >
                                Buscar
                            </Button>
                            <Button
                                $backgroundColor={theme!.colors.warning}
                                type="button"
                                onClick={handleLimparRelatorio}
                            >
                                Limpar
                            </Button>
                        </GroupButtons>
                        {
                            dadosRelatorio
                                ? <Table>
                                    <Thead>
                                        <Tr>
                                            <Th>Categoria de Pagamento</Th>
                                            <Th>Entrou</Th>
                                            <Th>Não Entrou</Th>
                                        </Tr>
                                    </Thead>
                                    <TBody>
                                        {
                                            dadosRelatorio.entrouNaoPagante > 0 || dadosRelatorio.naoEntrouNaoPagante > 0
                                                ? <Tr>
                                                    <Td>Não Pagante</Td>
                                                    <Td>{dadosRelatorio.entrouNaoPagante}</Td>
                                                    <Td>{dadosRelatorio.naoEntrouNaoPagante}</Td>
                                                </Tr>
                                                : <></>
                                        }
                                        {
                                            dadosRelatorio.entrouMeia > 0 || dadosRelatorio.naoEntrouMeia > 0
                                                ? <Tr>
                                                    <Td>Pagante Meia</Td>
                                                    <Td>{dadosRelatorio.entrouMeia}</Td>
                                                    <Td>{dadosRelatorio.naoEntrouMeia}</Td>
                                                </Tr>
                                                : <></>
                                        }
                                        {
                                            dadosRelatorio.entrouInteira > 0 || dadosRelatorio.naoEntrouInteira > 0
                                                ? <Tr>
                                                    <Td>Pagante Inteira</Td>
                                                    <Td>{dadosRelatorio.entrouInteira}</Td>
                                                    <Td>{dadosRelatorio.naoEntrouInteira}</Td>
                                                </Tr>
                                                : <></>
                                        }
                                        <Tr>
                                            <Th>Total</Th>
                                            <Th>{dadosRelatorio.totalEntrou}</Th>
                                            <Th>{dadosRelatorio.totalNaoEntrou}</Th>
                                        </Tr>
                                    </TBody>
                                </Table>
                                : <></>
                        }
                        <GroupButtons>
                            <Button 
                                $backgroundColor={theme!.colors.warning}
                                type="button"
                                onClick={() => navigate('/')}
                            >
                                Voltar
                            </Button>
                        </GroupButtons>
                    </Container>
            }
        </>
    )
}

export default Score